
import { useEffect } from 'react'
import Select from 'react-select'
import { ParameterTypeDDLAPI, QualityParameterNameDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const STPQualityParameterNameDataDDL = (props) => {
    const { QualityParameterName, setQualityParameterName, ParameterType, IsPost } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_IndicatorParameterTypeID: ParameterType.ID,
            M_UserID: UserID,
            token: token,
        }
        // if (UnitType.ID) {
        dispatch(QualityParameterNameDDLAPI({ data }))
        // }
    }, [IsPost,ParameterType.ID])

    const { QualityParameterNameData } = useSelector(state => state.QualityParameterNameDDL)

    useEffect(() => {
        handleSTPQualityParameterNameDDL()
    }, [QualityParameterNameData])

    const handleSTPQualityParameterNameDDL = () => {
        // console.log(DeptDDLDataa)
        if (QualityParameterNameData && QualityParameterNameData.table && QualityParameterNameData.table.length > 0) {
            let list = QualityParameterNameData.table.map((item, index) => ({
                value: item.m_stP_EquipmentMasterID,
                label: item.qualityParameterName,
            }))

            // setEmployeeDDL({
            //     DDL: list,
            //     ID: Flag === 'Update' ? rowData.m_EmployeeID : 0,
            //     Label: Flag === 'Update' ? rowData.employeeName : "Select...",
            // })
            setQualityParameterName({ ...QualityParameterName, DDL: list })
        }
        else {
            setQualityParameterName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }
    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Quality Parameter Name </b></label>
            <Select
                // isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: QualityParameterName.ID, label: QualityParameterName.Label }}
                onChange={(e) => {
                    e ?
                        setQualityParameterName({ ...QualityParameterName, ID: e.value, Label: e.label })
                        :
                        setQualityParameterName({ ...QualityParameterName, ID: 0, Label: "Select..." })

                }}
                options={QualityParameterName.DDL}
            />
        </div>
    )
}